import React from "react";
import { Modal } from "antd";
import { BorderedButton } from "../../commonComponents";
import {
  UNSUPPORTED_CURRENCY_TITLE,
  UNSUPPORTED_CURRENCY_MESSAGE,
} from "../../../helpers/walletCurrency";
import "./UnsupportedCurrency.scss";

// Copy lives in helpers/walletCurrency.js alongside the supported-currency
// constant, so a change in BetArabia's LBP position is a one-file edit.
const UnsupportedCurrency = ({ visible, closeModal }) => {
  return (
    <Modal
      open={visible}
      title={UNSUPPORTED_CURRENCY_TITLE}
      onCancel={closeModal}
      wrapClassName="unsupportedcurrency-modal"
      className="unsupportedcurrency-modal-inner"
      footer={null}
      maskStyle={{
        backdropFilter: "blur(5px)",
      }}
    >
      <p className="unsupportedcurrency-modal-details font-cairo-normal">
        {UNSUPPORTED_CURRENCY_MESSAGE}
      </p>
      <div className="unsupportedcurrency-modal-buttons">
        <BorderedButton
          name={"Close"}
          btnClass="alert-buttons-discard"
          functionCall={closeModal}
        />
      </div>
    </Modal>
  );
};
export default UnsupportedCurrency;
